var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-navigation-drawer",
    {
      class: [
        "shadow-left safe-bottom-margin",
        _vm.$vuetify.breakpoint.width < 800 ? "peek soli-round" : null,
      ],
      staticStyle: { "z-index": "10 !important", "max-height": "100%" },
      attrs: {
        width:
          _vm.$vuetify.breakpoint.width < 800 ? "-webkit-fill-available" : 300,
        bottom: _vm.$vuetify.breakpoint.width < 800 ? true : false,
        right: _vm.$vuetify.breakpoint.width >= 800 ? true : false,
        app: "",
        "mobile-breakpoint": "799",
        "disable-resize-watcher": "",
        touchless: "",
        id: "manageAssign",
      },
      on: { input: _vm.closeAvail },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-list",
        {
          staticClass: "px-4 soli-round",
          staticStyle: {
            position: "fixed",
            background: "white",
            width: "-webkit-fill-available",
            "z-index": "11px",
          },
        },
        [
          _c(
            "div",
            { staticClass: "soli-caption" },
            [
              _vm._v("\n            Room Assignment\n            "),
              _c(
                "v-btn",
                {
                  staticClass: "cancel-btn mr-1",
                  attrs: { icon: "" },
                  on: {
                    click: function ($event) {
                      return _vm.closeAvail(false)
                    },
                  },
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-list-item-title",
            { staticClass: "soli-subtitle" },
            [
              _c(
                "Link",
                { attrs: { href: `/profile/${_vm.teacherId}/availability` } },
                [_vm._v(_vm._s(_vm.teacherName))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: [
            "sidebar-fullcalendar",
            _vm.showEditing
              ? _vm.deleteAssign
                ? "pad-bottom-delete "
                : "pad-bottom"
              : null,
          ],
          staticStyle: {
            position: "absolute",
            height: "calc(100% - 64px)",
            width: "100%",
            top: "64px",
          },
        },
        [
          _c(
            "v-overlay",
            {
              staticStyle: { "z-index": "12" },
              attrs: { value: _vm.apiLoading },
            },
            [
              _c("v-progress-circular", {
                attrs: { indeterminate: "", size: "64" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("FullCalendar", {
            ref: "fullCalendar",
            staticClass: "animate__animated animate__fadeIn",
            attrs: { id: "assignFC", options: _vm.calendarOptions },
            scopedSlots: _vm._u([
              {
                key: "eventContent",
                fn: function (arg) {
                  return [
                    arg.event.display !== "background"
                      ? _c(
                          "div",
                          { class: arg.timeText ? "pt-1 pl-2" : null },
                          [
                            arg.timeText
                              ? _c(
                                  "b",
                                  {
                                    class:
                                      arg.isMirror ||
                                      arg.event.extendedProps.temp
                                        ? "soli-grey"
                                        : null,
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(arg.timeText) +
                                        "\n                        "
                                    ),
                                    !arg.isMirror &&
                                    !arg.event.extendedProps.temp &&
                                    !arg.event.extendedProps.lessons.length
                                      ? _c(
                                          "v-btn",
                                          {
                                            staticClass: "float-right",
                                            attrs: { icon: "" },
                                            on: {
                                              click: function ($event) {
                                                _vm.deleteAssign = true
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                staticClass: "white--text",
                                                attrs: { dense: "", small: "" },
                                              },
                                              [_vm._v("delete")]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c("br"),
                            _vm._v(" "),
                            !arg.isMirror && !arg.event.extendedProps.temp
                              ? _c("div", [
                                  _c(
                                    "div",
                                    { class: ["flex align-center mt-1"] },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "mr-1",
                                          attrs: {
                                            "x-small": "",
                                            color: "white",
                                          },
                                        },
                                        [_vm._v("meeting_room")]
                                      ),
                                      _vm._v(" "),
                                      _c("small", [
                                        _vm._v(_vm._s(arg.event.title)),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  arg.event.extendedProps.recurrence_end &&
                                  !arg.event.extendedProps.removed_from_series
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "flex align-center mt-1",
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              staticClass: "mr-1",
                                              attrs: {
                                                "x-small": "",
                                                color: "white",
                                              },
                                            },
                                            [_vm._v("event_busy")]
                                          ),
                                          _vm._v(" "),
                                          _c("small", [
                                            _vm._v(
                                              _vm._s(
                                                `Until ${_vm.globalMomentDate(
                                                  arg.event.extendedProps
                                                    .recurrence_end
                                                )}`
                                              )
                                            ),
                                          ]),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  arg.event.extendedProps.removed_from_series
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "flex align-center mt-1",
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              staticClass: "mr-1",
                                              attrs: {
                                                "x-small": "",
                                                color: "white",
                                              },
                                            },
                                            [_vm._v("event_busy")]
                                          ),
                                          _vm._v(" "),
                                          _c("small", [
                                            _vm._v("Removed from series"),
                                          ]),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  arg.event.extendedProps.lessons.length
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "mt-1 flex align-center",
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              staticClass: "mr-1",
                                              attrs: {
                                                "x-small": "",
                                                color: "white",
                                              },
                                            },
                                            [_vm._v("timeline")]
                                          ),
                                          _vm._v(" "),
                                          _c("small", [
                                            _vm._v(
                                              _vm._s(
                                                `${
                                                  /*.filter(
                                            i =>
                                                globalMomentCompareDate(
                                                    i.starts_at
                                                ) ==
                                                globalMomentCompareDate(
                                                    arg.event.start
                                                )
                                        )*/
                                                  arg.event.extendedProps
                                                    .lessons.length
                                                } lesson(s)`
                                              )
                                            ),
                                          ]),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  arg.event.extendedProps.instruments
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "mt-1 flex align-center",
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              staticClass: "mr-1",
                                              attrs: {
                                                "x-small": "",
                                                color: "white",
                                              },
                                            },
                                            [_vm._v("music_note")]
                                          ),
                                          _vm._v(" "),
                                          _c("small", [
                                            _vm._v(
                                              _vm._s(
                                                arg.event.extendedProps
                                                  .instruments
                                              )
                                            ),
                                          ]),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ])
                              : _vm._e(),
                          ]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.lessonConflict
        ? _c("SoliChoice", {
            attrs: {
              title: "Uh oh",
              subtitle:
                "You are about to exclude scheduled lessons from this assignment. Please cancel those lessons before making this change.",
              button1: "Okay",
            },
            on: {
              option1: function ($event) {
                _vm.lessonConflict = false
              },
              reset: function ($event) {
                _vm.lessonConflict = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showMoveInStudioWarning
        ? _c("SoliChoice", {
            attrs: {
              permanent: "",
              title: "Are you sure?",
              subtitle: `You are moving this assignment in-studio. ${_vm.teacherName}'s lessons will remain online for students. ${_vm.teacherName}'s online room will no longer be available.`,
              button1: "I understand",
              button2: "Nevermind",
            },
            on: {
              option1: function ($event) {
                ;[
                  (_vm.form.reassignRoom = true),
                  (_vm.form.futureEvents =
                    !_vm.selectedAssign.removed_from_series),
                  _vm.closeModal(() => (_vm.showMoveInStudioWarning = false)),
                ]
              },
              reset: function ($event) {
                ;[
                  _vm.closeModal(() => (_vm.showMoveInStudioWarning = false)),
                  (_vm.saveChanges = false),
                ]
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showSubTeacherWarning
        ? _c("SoliChoice", {
            attrs: {
              permanent: "",
              title: "Are you sure?",
              subtitle: `${_vm.form.subTeacher?.teacher?.name} will replace ${_vm.teacherName} for this assignment and lessons. <br/><br/>
                    <ul>
                    <li> - ${_vm.selectedAssign?.teacher?.first_name}'s availability will be canceled </li>
                    <li> - Students and teachers will be notified automatically </li>
                    <li> - Previously canceled lessons will NOT be rescheduled </li>
                    <li> - Affected lessons will be set to teacher-canceled</li>
                    </ul>
                `,
              button1: "I understand",
              button2: "Nevermind",
            },
            on: {
              option1: function ($event) {
                ;[
                  (_vm.form.futureEvents = false),
                  _vm.closeModal(() => (_vm.showSubTeacherWarning = false)),
                ]
              },
              reset: function ($event) {
                ;[
                  _vm.closeModal(() => (_vm.showSubTeacherWarning = false)),
                  (_vm.form.subTeacher = null),
                  (_vm.saveChanges = false),
                ]
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showSplitAssignmentWarning
        ? _c("SoliChoice", {
            attrs: {
              permanent: "",
              title: "Are you sure?",
              subtitle: `This will split the assignment into two separate assignments. ${_vm.teacherName}'s lessons will be divided between the two assignments.`,
              button1: "I understand",
              button2: "Nevermind",
            },
            on: {
              option1: function ($event) {
                ;[
                  _vm.closeModal(
                    () => (_vm.showSplitAssignmentWarning = false)
                  ),
                ]
              },
              reset: function ($event) {
                ;[
                  _vm.closeModal(
                    () => (_vm.showSplitAssignmentWarning = false)
                  ),
                  (_vm.form.splitAssignment = null),
                  (_vm.saveChanges = false),
                ]
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.futureConflict
        ? _c("SoliChoice", {
            attrs: {
              title: "Uh oh",
              subtitle: `${
                _vm.futureConflict.roomConflict
                  ? _vm.futureConflict.roomConflict
                  : _vm.teacherName
              }${
                _vm.futureConflict.recurrence_id
                  ? ` is already assigned at this time, starting ${_vm.globalMomentDate(
                      //conflicts[0].starts_at
                      new Date(_vm.futureConflict.date)
                    )}. Would you like to schedule ${
                      _vm.teacherName.split(" ")[0]
                    } until then?`
                  : ` is unavailable at this time`
              }`,
              button1: _vm.futureConflict.recurrence_id ? "Ok" : null,
              button2: "Go back",
            },
            on: {
              reset: function ($event) {
                _vm.futureConflict = null
              },
              option1: function ($event) {
                ;(_vm.form.recurrence_end = _vm.futureConflict.date),
                  (_vm.form.noConflict = true),
                  _vm.editing ? _vm.editEvent() : _vm.addEvent()
              },
              option2: function ($event) {
                ;[
                  _vm.cancelAssign(),
                  _vm.getEvents(),
                  (_vm.showEditing = false),
                  (_vm.form.noConflict = false),
                ]
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.availConflict
        ? _c("SoliChoice", {
            attrs: {
              title: "Hey!",
              subtitle: `This availability ends on ${_vm.globalMomentDate(
                new Date(_vm.availability.recurrence.ends_at)
              )}. Would you like to assign ${
                _vm.availability.teacher.first_name
              } until then?`,
              button1: "Yep!",
            },
            on: {
              reset: function ($event) {
                _vm.availConflict = null
              },
              option1: function ($event) {
                _vm.form.recurrence_end = _vm.globalMomentDate(
                  new Date(_vm.availability.recurrence.ends_at)
                )
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showEditing
        ? _c(
            "v-bottom-sheet",
            {
              staticClass: "half-round",
              attrs: {
                id: "edit-assignment",
                value: _vm.showEditing,
                "content-class": "fixed right-0 half-round",
                width:
                  _vm.$vuetify.breakpoint.width < 800
                    ? "-webkit-fill-available"
                    : 300,
                persistent: "",
                "hide-overlay": "",
              },
            },
            [
              _c(
                "v-card",
                { staticClass: "half-round" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "ma-3 soli-close",
                      attrs: { icon: "" },
                      on: {
                        click: function ($event) {
                          return _vm.cancelAssign(true)
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("clear")])],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-card-title", { staticClass: "soli-grey" }, [
                    _vm._v(_vm._s(_vm.getFormTitle)),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-card-subtitle",
                    { staticClass: "soli-grey pt-2 pb-0 flex" },
                    [
                      _c(
                        "v-icon",
                        { staticClass: "mr-1", attrs: { small: "" } },
                        [_vm._v("today")]
                      ),
                      _vm._v(" "),
                      _c("v-card-text", { staticClass: "pa-0" }, [
                        _vm._v(
                          _vm._s(
                            `${_vm.form.startDate}${
                              _vm.form.recurrence_end
                                ? ` until ${this.globalMomentDate(
                                    new Date(_vm.form.recurrence_end)
                                  )}`
                                : " and future events"
                            }`
                          )
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.editing
                    ? _c(
                        "v-card-subtitle",
                        { staticClass: "soli-grey pb-0 flex" },
                        [
                          _c(
                            "v-icon",
                            { staticClass: "mr-1", attrs: { small: "" } },
                            [_vm._v("repeat")]
                          ),
                          _vm._v(" "),
                          _c("v-card-text", { staticClass: "pa-0" }, [
                            _vm._v(
                              _vm._s(`
                            Weekly on ${_vm.globalMomentWeekDay(
                              new Date(_vm.form.startDate)
                            )}s`)
                            ),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-card-subtitle",
                    { staticClass: "soli-grey pb-0 flex" },
                    [
                      _c(
                        "v-icon",
                        { staticClass: "mr-1", attrs: { small: "" } },
                        [_vm._v("schedule")]
                      ),
                      _vm._v(" "),
                      _c("v-card-text", { staticClass: "pa-0" }, [
                        _vm._v(
                          _vm._s(
                            `${_vm.globalMomentTime(
                              _vm.form.startTime
                            )} to ${_vm.globalMomentTime(_vm.form.endTime)}`
                          )
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.form.affectedLessons.length && _vm.editing
                    ? _c(
                        "v-expansion-panels",
                        {
                          staticClass: "ma-0",
                          attrs: { accordian: "", flat: "" },
                          model: {
                            value: _vm.panel,
                            callback: function ($$v) {
                              _vm.panel = $$v
                            },
                            expression: "panel",
                          },
                        },
                        [
                          _c(
                            "v-expansion-panel",
                            { class: ["ma-0"] },
                            [
                              _c(
                                "v-expansion-panel-header",
                                {
                                  staticClass: "pr-8 pl-2 py-0",
                                  staticStyle: { "min-height": "1rem" },
                                  attrs: {
                                    "expand-icon": "keyboard_arrow_down",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "actions",
                                        fn: function () {
                                          return [
                                            _c(
                                              "v-icon",
                                              { attrs: { color: "soli-grey" } },
                                              [_vm._v(" $expand ")]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    1597335737
                                  ),
                                },
                                [
                                  _vm._v(" "),
                                  _c(
                                    "v-card-subtitle",
                                    { staticClass: "pb-0 pt-0 soli-grey flex" },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "mr-1",
                                          attrs: { small: "" },
                                        },
                                        [_vm._v("timeline")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-card-text",
                                        { staticClass: "pa-0" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              `${_vm.form.affectedLessons.length} lesson(s)`
                                            )
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-expansion-panel-content",
                                {
                                  staticClass: "soli-grey pt-4",
                                  staticStyle: {
                                    overflow: "auto",
                                    "max-height": "400px",
                                  },
                                },
                                _vm._l(_vm.affectedLessons, function (lesson) {
                                  return _c(
                                    "div",
                                    { key: lesson.id, staticClass: "pa-2" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "caption pb-0.5" },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(lesson.type) +
                                              "\n                            "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      lesson.student
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "subtitle-2 font-bold",
                                              staticStyle: {
                                                "line-height":
                                                  "16px !important",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                " +
                                                  _vm._s(lesson.student.name) +
                                                  "\n                            "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("small", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.globalMomentFullDateAtTimeShort(
                                              lesson.starts_at
                                            )
                                          )
                                        ),
                                      ]),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("v-divider", { staticClass: "mx-3 mt-3" }),
                  _vm._v(" "),
                  _c(
                    "v-container",
                    [
                      !_vm.deleteAssign
                        ? _c(
                            "v-form",
                            {
                              staticClass: "flex flex-col gap-4",
                              attrs: { disabled: _vm.selectedAssign.cancelled },
                            },
                            [
                              _c("v-select", {
                                staticClass: "px-3",
                                attrs: {
                                  disabled:
                                    !!_vm.form.subTeacher ||
                                    !!_vm.form.splitAssignment /*
                            selectedAssign.availability
                                ? selectedAssign.availability.online_only
                                : false*/,
                                  items: _vm.rooms.filter((e) => {
                                    if (e.user_id) {
                                      return e.user_id == _vm.teacherId
                                    }
                                    return e
                                    /*if (!getAvailability.online_only) {
                                    return !e.user_id;
                                } else {
                                    return e.user_id;
                                }*/
                                  }),
                                  "item-value": "id",
                                  "item-text": "title",
                                  label: "Room",
                                  "return-object": "",
                                  "prepend-inner-icon": "meeting_room",
                                  outlined: "",
                                  dense: "",
                                  "hide-details": "auto",
                                },
                                on: {
                                  change: function ($event) {
                                    ;[
                                      (_vm.saveChanges = true),
                                      _vm.selectedAssign.room?.user_id
                                        ? (_vm.showMoveInStudioWarning = true)
                                        : null,
                                    ]
                                  },
                                },
                                model: {
                                  value: _vm.form.room,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "room", $$v)
                                  },
                                  expression: "form.room",
                                },
                              }),
                              _vm._v(" "),
                              _c("v-select", {
                                staticClass: "px-3",
                                attrs: {
                                  label: "Sub Teacher",
                                  items: _vm.getSubTeachers(),
                                  disabled:
                                    _vm.form.room?.id !==
                                      _vm.selectedAssign.room?.id ||
                                    !!_vm.form.splitAssignment,
                                  "item-value": "id",
                                  "item-text": "teacher.name",
                                  "return-object": "",
                                  "prepend-inner-icon": "group_add",
                                  "hide-details": "auto",
                                  outlined: "",
                                  dense: "",
                                  noDataText: "No teachers available",
                                },
                                on: {
                                  change: function ($event) {
                                    ;[
                                      (_vm.saveChanges = true),
                                      (_vm.showSubTeacherWarning = true),
                                    ]
                                  },
                                },
                                model: {
                                  value: _vm.form.subTeacher,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "subTeacher", $$v)
                                  },
                                  expression: "form.subTeacher",
                                },
                              }),
                              _vm._v(" "),
                              _c("v-select", {
                                staticClass: "px-3",
                                attrs: {
                                  items: _vm.splitAssignmentIntervals,
                                  disabled:
                                    !!_vm.form.subTeacher ||
                                    _vm.form.room?.id !==
                                      _vm.selectedAssign.room?.id,
                                  label: "Split Assignment",
                                  "item-value": "value",
                                  "item-text": "text",
                                  "prepend-inner-icon": "content_cut",
                                  outlined: "",
                                  dense: "",
                                  "hide-details": "auto",
                                },
                                on: {
                                  input: function ($event) {
                                    ;[
                                      (_vm.saveChanges = true),
                                      (_vm.showSplitAssignmentWarning = true),
                                    ]
                                  },
                                },
                                model: {
                                  value: _vm.form.splitAssignment,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "splitAssignment", $$v)
                                  },
                                  expression: "form.splitAssignment",
                                },
                              }),
                              _vm._v(" "),
                              _c("SoliBtn", {
                                staticClass: "flex",
                                attrs: {
                                  gradient: "gradient-orange",
                                  disabled: !_vm.saveChanges,
                                  loading: _vm.loading,
                                  block: "",
                                  text: "Save",
                                  icon: "save",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.editing
                                      ? _vm.editEvent()
                                      : _vm.addEvent()
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.deleteAssign
                        ? _c(
                            "div",
                            { staticClass: "flex" },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    color: "secondary",
                                    rounded: "",
                                    text: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.editEvent()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                        Delete!\n                    "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    color: "primary",
                                    text: "",
                                    rounded: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      ;[
                                        _vm.cancelAssign(true),
                                        (_vm.deleteAssign = false),
                                      ]
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                        No, take me back\n                    "
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }